import React from "react";

const ModalInsert = (props) => {
  const { className, children } = props;
  return <div className={className}>{children}</div>;
};

export default ModalInsert;
